import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import MainTable from "../components/main-tables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { Button, InputAdornment, TextField } from "@mui/material";
import {
  list_wtax_master,
  wtax_master_isFirst,
} from "../../redux/sap-master/list-wtax-master";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import { useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  sink_wtax_isSuccess,
  sink_wtax_master,
} from "../../redux/sap-master/wtax-sink-master";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
const WtaxMaster = () => {
  const dispatch = useDispatch();
  const wtax_master_data = useSelector((state: any) => state.WTAXMasterListApi);
  const [search, setSearch] = useState<string>("");
  const [activePartner, setActivePartner] = React.useState<null | number>(null);
  const wtaxSinkApi = useSelector((state: any) => state.SinkwtaxMaster);
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const activeData = activeDatas.data;
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  // useEffect
  useEffect(() => {
    dispatch(list_wtax_master(""));
    if (wtaxSinkApi.isSuccess) {
      dispatch(sink_wtax_isSuccess(""));
    }
  }, [wtaxSinkApi]);

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setActivePartner(null);
    setShowBack(false);
    setTitleContext("WTAX Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.WTName) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.WTName ?? "WTAX Master");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    for (let i = 0; i < wtax_master_data.data.data.length; i++) {
      let data = { ...wtax_master_data.data.data[i] };
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const Effec_Date = new Date(data.EffecDate);
      // delete data.EffecDate;
      const EffecDate =
        Effec_Date.getDate() +
        "-" +
        monthNames[Effec_Date.getMonth()] +
        "-" +
        Effec_Date.getFullYear();
      data.EffecDate ? (data.EffecDate = EffecDate) : console.log("sdfdsf");

      // create on
      const created_on = new Date(data.created_on);
      // delete data.EffecDate;
      const created_date =
        created_on.getDate() +
        "-" +
        monthNames[created_on.getMonth()] +
        "-" +
        created_on.getFullYear();
      data.created_on
        ? (data.created_on = created_date)
        : console.log("sdfdsf");

      // update on
      const updated_on = new Date(data.updated_on);
      // delete data.EffecDate;
      const update_date =
        updated_on.getDate() +
        "-" +
        monthNames[updated_on.getMonth()] +
        "-" +
        updated_on.getFullYear();
      data.updated_on ? (data.updated_on = update_date) : console.log("sdfdsf");

      filterarr.push(data);
    }
    filterarr.filter((e) => delete e.id);

    filterarr.filter((e) => delete e.created_by);
    filterarr.filter((e) => delete e.updated_by);

    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display:
                isMobile && typeof activePartner === "number"
                  ? "none"
                  : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              WTAX Master
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(sink_wtax_master(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (wtax_master_data.isFirst && key === 0) {
                    dispatch(wtax_master_isFirst(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          activePartner === key ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.WTName}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.WTCode}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display:
                isMobile && typeof activePartner !== "number"
                  ? "none"
                  : "initial",
            }}
          >
            {typeof activePartner !== "number" ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One WTAX
              </div>
            ) : (
              <div className="scroll_content_container scroll_content_container_2">
                <div className="grid_container">
                  <div className="detail_item">
                    <label className="f4">WTAX Name</label>
                    <p>{activeData.WTName ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">WTAX Code</label>
                    <p>{activeData.WTCode ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Assessee</label>
                    <p>{activeData.Assessee ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Offcl Code</label>
                    <p>{activeData.OffclCode ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">EffecDate</label>
                    <p>{activeData.EffecDate ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Active</label>
                    <p>{activeData.active ? "Active" : "inActive"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Create On</label>
                    <p>{activeData.created_on}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Update On</label>
                    <p>{activeData.updated_on}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <div className="partner-details">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={
            wtax_master_data.isLoading || wtaxSinkApi.isLoading ? true : false
          }
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {/* <div className="title d-flex">
          <h5>WTAX Master</h5>
          <div className="ms-auto me-2">
            <FontAwesomeIcon
              onClick={() => {
                dispatch(list_wtax_master(""));
              }}
              style={{
                fontSize: "22px",
                cursor: "pointer",
              }}
              icon={["fas", "arrows-rotate"]}
            />
          </div>
        </div> */}
        {wtax_master_data.isSuccess ? (
          mainTable()
        ) : (
          <div className="not_found_container">
            <img src={DataNotFound} alt="" />
            No Data Found
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default WtaxMaster;
